// src/translations/howItWorks.js

const howItWorksTranslations = {
  en: {
    pageTitle: 'How It Works',
    sectionTitle: 'How does it work?',
    intro:
      'Network Assistant is a tool that uses artificial intelligence to quickly and efficiently find the most suitable person for you, whether it be an investor, employer, business partner, employee, or friend.',
    body1:
      'The user registers on the platform and opens a chat with the AI assistant. While communicating with the AI, you describe in as much detail as possible who you are looking for and why this person should connect with you.',
    body2:
      'The quality of the selection will depend on how objective and complete the information you provide about yourself is. You can run several selections at the same time — as many as you need!',
    gdprNotice: 'All information you provide is protected by blockchain technology in compliance with GDPR',
    gdprLink: 'check GDPR compliance information here',
  },
  fr: {
    pageTitle: 'Comment ça marche ?',
    sectionTitle: 'Comment ça marche ?',
    intro:
      "Network Assistant est un outil qui utilise l'intelligence artificielle pour trouver rapidement et efficacement la personne la plus adaptée pour vous, qu'il s'agisse d'un investisseur, d'un employeur, d'un partenaire commercial, d'un employé ou d'un ami.",
    body1:
      "L'utilisateur s'inscrit sur la plateforme et ouvre un chat avec l'assistant IA. En communiquant avec l'IA, vous décrivez le plus en détail possible qui vous recherchez et pourquoi cette personne devrait se connecter avec vous.",
    body2:
      "La qualité de la sélection dépendra de l'objectivité et de la complétude des informations que vous fournissez sur vous-même. Vous pouvez lancer plusieurs sélections en même temps — autant que vous en avez besoin !",
    gdprNotice:
      'Toutes les informations que vous fournissez sont protégées par la technologie blockchain en conformité avec le RGPD',
    gdprLink: 'consultez les informations sur la conformité RGPD ici',
  },
};

export const getHowItWorksText = (lang) =>
  howItWorksTranslations[lang] ?? howItWorksTranslations.en;
